<template>
  <l-select v-model="model" :items="items"/>
</template>

<script setup>
import LSelect from "@/components/inputs/LSelect.vue"
import { computed } from "vue"

const model = defineModel(Number)

const props = defineProps({
  items: Array,
})

const items = computed(() => props.items.map(year => ({ value: year, text: `${year}-${year - 1999}` })))
</script>
